import {createSlice} from "@reduxjs/toolkit";

const initialState: any = {
  messagesAlarm: [],
};

const alarmSlice = createSlice({
  name: 'messagesAlarm',
  initialState,
  reducers: {
    updateAlarmMessages: (state, action) => {
      state.messagesAlarm = action.payload;
    },
    readAlarmMessage: (state, action) => {
      const index = action.payload; // assuming payload is the index of the message to be removed
      if (index > -1) {
      }
    },
    readAllAlarmMessages: (state, action) => {
      state.messagesAlarm = action.payload; // Clear all messages
    },
  },
});

export default alarmSlice.reducer;
export const {
  updateAlarmMessages,
  readAlarmMessage,
  readAllAlarmMessages,
} = alarmSlice.actions;